import React, { useState, useEffect } from 'react'
import { Form } from 'react-bootstrap';
import SaveButton from '../../component/buttons/SaveButton';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../../component/loader/Loader';
import { configurationListTodo } from '../../redux/slices/tooling-configuration/ConfigurationList';

export default function UploadFiles() {
    const [defectData, setDefectData] = useState('');
    const [loading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const configuration = useSelector(state => state?.configurationList?.data?.data?.[0])


    let defect_item = [];
    try {
        defect_item = configuration?.defect && configuration.defect !== "undefined"
            ? JSON.parse(configuration.defect)
            : [];
    } catch (e) {
        defect_item = [];
    }
    // console.log(defect_item)

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file && file.type === 'text/csv') {
            const reader = new FileReader();
            reader.onload = (event) => {
                setDefectData(event.target.result); // Set CSV text in textarea
            };
            reader.readAsText(file);
        } else {
            alert('Please upload a valid CSV file.');
        }
    };

    useEffect(() => {
        setLoading(true)
        dispatch(configurationListTodo()).then(() => list_res())

    }, [])

    const list_res = (res) => {
        if (res?.status) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }

    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    {loading ?
                        <div>
                            <Loader />
                        </div> :
                        <div className="col-md-3">
                            <div className="main_layout">
                                <h6>Defect Data</h6>
                                <hr />
                                <div>

                                    <div className='d-flex justify-content-between align-items-center mt-2'>
                                        <p className="form_label mb-0">Min Edge Trim (mm)</p>
                                        <span>{configuration?.min_edge}</span>
                                    </div>
                                    <hr />
                                    <div className='d-flex justify-content-between align-items-center mt-2'>
                                        <p className="form_label mb-0">Max Edge Trim (mm)</p>
                                        <span>{configuration?.max_edge}</span>
                                    </div>
                                    <hr />
                                    <div className='d-flex justify-content-between align-items-center mt-2'>
                                        <p className="form_label mb-0">Min Good Piece Length (m)</p>
                                        <span>{configuration?.min_good_piece_length}</span>
                                    </div>
                                    <hr />
                                    <div className='d-flex justify-content-between align-items-center mt-2'>
                                        <p className="form_label mb-0">Min Final Length (m)</p>
                                        <span>{configuration?.min_final_length}</span>
                                    </div>
                                    <hr />
                                    <div className='d-flex justify-content-between align-items-center mt-2'>
                                        <p className="form_label mb-0">Max Welds per Coil(as per min final length)</p>
                                        <span>{configuration?.max_welds}</span>
                                    </div>
                                    <hr />
                                    <div>
                                        <p className="form_label mb-0">Defects</p>
                                        {defect_item?.map((val, index) =>
                                            <span>{val?.label} , </span>
                                        )}
                                    </div>
                                    <hr />
                                    <Form.Group controlId="fileInput" className='text-center'>
                                        <Form.Label className='save_btn pt-2 pb-2 pe-5  ps-5 ' style={{ width: '100%' }}>Upload</Form.Label>
                                        <Form.Control style={{ display: 'none' }} type="file" accept=".csv" onChange={handleFileChange} />
                                    </Form.Group>


                                    {/* <Form.Group controlId="textarea">
                                    <Form.Control
                                        as="textarea"
                                        rows={15}
                                        className='config_filed'
                                        name='defect_data'
                                        value={defectData}
                                        onChange={(e) => setDefectData(e.target.value)}
                                    />
                                </Form.Group>
                              
                                <div className="col-md-12 mt-3">
                                    <div xl='12' className='d-flex justify-content-center'>
                                        <SaveButton name={'Generate Optimal Plan'} />
                                    </div>
                                </div> */}
                                </div>
                            </div>
                        </div>}
                </div>
            </div>
        </>
    )
}
